import { useState } from "react";
import type { ProductDetail } from "@/mocks/productDetails";

const tabs = [
  { id: "descricao", label: "Descrição" },
  { id: "detalhes", label: "Características" },
  { id: "envio", label: "Envio e Trocas" },
];

export default function ProductTabs({ detail }: { detail: ProductDetail }) {
  const [activeTab, setActiveTab] = useState("descricao");

  return (
    <section className="mt-16 border-t border-background-200 pt-10">
      <div className="flex flex-wrap gap-1 rounded-full bg-background-100 p-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setActiveTab(tab.id)}
            className={`whitespace-nowrap rounded-full px-5 py-2 text-sm transition-colors ${
              activeTab === tab.id
                ? "bg-background-50 font-semibold text-primary-800"
                : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="mt-6 max-w-3xl">
        {activeTab === "descricao" && (
          <p className="text-sm leading-relaxed text-foreground-700">{detail.description}</p>
        )}

        {activeTab === "detalhes" && (
          <ul className="space-y-3">
            {detail.features.map((feature) => (
              <li key={feature} className="flex items-start gap-3">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center text-primary-600">
                  <i className="ri-check-double-line text-base"></i>
                </span>
                <span className="text-sm leading-relaxed text-foreground-700">{feature}</span>
              </li>
            ))}
            <li className="flex items-start gap-3">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center text-primary-600">
                <i className="ri-price-tag-3-line text-base"></i>
              </span>
              <span className="text-sm leading-relaxed text-foreground-700">
                Código do produto: {detail.sku}
              </span>
            </li>
          </ul>
        )}

        {activeTab === "envio" && (
          <div className="space-y-4 text-sm leading-relaxed text-foreground-700">
            <p>
              Enviamos para todo o Brasil com <strong className="font-medium text-foreground-900">frete grátis</strong>.
              O prazo de entrega varia de acordo com a sua região e é calculado no momento do checkout.
            </p>
            <p>
              Você tem até <strong className="font-medium text-foreground-900">30 dias</strong> após o recebimento para
              solicitar troca ou devolução, sem custo adicional. Nossa equipe de atendimento está disponível para
              ajudar em cada etapa.
            </p>
            <p>
              Todas as peças são enviadas em embalagem exclusiva, protegidas e prontas para presentear.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}